import React, { useState } from "react";

import { applyStyleToSelectedRange, applyLinkToSelectedRange, removeLinkFromSelectedRange, LinkPopover } from "../../RichTextEditor";
import Button from "../../Shared/UI/Button/components/Button";
import BoldIcon from '../../Shared/UI/BoldIcon/components/BoldIcon';
import ItalicIcon from '../../Shared/UI/ItalicIcon/components/ItalicIcon';
import LinkIcon from '../../Shared/UI/LinkIcon/components/LinkIcon';

import styles from './PostRichTextEditor.module.scss';

const PostFormattingControls = ({ contentEditable, setState, activeStyleTypes = [], activeFormat, activeHref, editableContentId }) => {
  const [linkPopoverOpen, setLinkPopoverOpen] = useState(false);

  return (
    <>
      {contentEditable && (
        <div className={styles.toolbar}>
          <Button
            variant="secondary"
            icon={<BoldIcon />}
            iconOnly
            aria-label="Bold"
            pressed={activeStyleTypes.includes('b')}
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => applyStyleToSelectedRange({ style: { type: 'b' }, setState })}
          />
          <Button
            variant="secondary"
            icon={<ItalicIcon />}
            iconOnly
            aria-label="Italic"
            pressed={activeStyleTypes.includes('i')}
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => applyStyleToSelectedRange({ style: { type: 'i' }, setState })}
          />
          <LinkPopover
            isOpen={linkPopoverOpen}
            onClose={() => setLinkPopoverOpen(false)}
            onApply={(href) => {
              setLinkPopoverOpen(false);
              applyLinkToSelectedRange({ href, setState, editableContentId });
            }}
            onRemove={() => {
              setLinkPopoverOpen(false);
              removeLinkFromSelectedRange({ setState, editableContentId });
            }}
            initialHref={activeHref}
          >
            <Button
              variant="secondary"
              icon={<LinkIcon />}
              iconOnly
              aria-label="Link"
              pressed={activeStyleTypes.includes('a')}
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => setLinkPopoverOpen(!linkPopoverOpen)}
            />
          </LinkPopover>
        </div>
      )}
    </>
  );
};

export default PostFormattingControls;
